import React from 'react'
import Nav from '../Global/Nav'
import Footer from '../Global/Footer'
import QuoteHero from './QuoteHero'
import QuoteForm from './QuoteForm'

const RequestQuote = () => {
  return (
    <>
    <Nav />
    <QuoteHero />
  <QuoteForm />
    <Footer />
    </>
  )
}

export default RequestQuote
